import { createFileRoute } from '@tanstack/react-router'
import { Puzzle } from 'lucide-react'
import { IntegrationsScreen } from '@/screens/connect/SCR-043-integrations'

export const Route = createFileRoute('/_app/connect/integrations')({
  staticData: { screen: { id: 'SCR-043', title: 'Product integrations', group: 'Connect', perm: 'connector.manage', order: 6, description: 'Claude Code, Cursor, Hermes, any MCP client, REST and RAS: which ones your organisation really uses, and how to set up the others.', icon: Puzzle } },
  component: IntegrationsScreen,
})
